import React from "react";
import { ThinTextField } from "../../common/GeneralComponent";

const FeatureInformation = ({ data }) => {
  if (!data) {
    return (
      <div className="text-center py-8 text-gray-500">No data available</div>
    );
  }

  const featureType = data.feature_name || "N/A";
  const subType = data.feature_sub_type || "N/A";
  const category = data.category_name || "N/A";
  const featureCode = data.proposed_code || "N/A";
  const locationVerified = data.location_verified_on_site || "N/A";
  const currentlyFunctional = data.feature_currently_functional || "N/A";
  const conditionObserved = data.condition_observed || "N/A";
  const physicalProgress = data.physical_progress ? `${data.physical_progress}%` : "N/A";
  const featureUsedByCommunity = data.feature_used_by_community || "N/A";
  const communityInvolvedInPlanning = data.community_involved_in_planning || "N/A";

  return (
    <div className="bg-white rounded p-4">
      <form className="w-full">
        {/* First Row - Type, Sub-Type, Category */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Type of Feature"
            value={featureType}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Sub-Type"
            value={subType}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Feature Category / Specific Feature Name"
            value={category}
            disabled
          />
        </div>

        {/* Second Row - Feature Code, Location Verified, Currently Functional */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Feature Code"
            value={featureCode}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Location Verified on Site"
            value={locationVerified}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Feature Currently Functional"
            value={currentlyFunctional}
            disabled
          />
        </div>

        {/* Third Row - Condition, Physical Progress, Feature in Use */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Condition Observed"
            value={conditionObserved}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Physical Progress (Observed % Estimate)"
            value={physicalProgress}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Is the feature in active use by the community?"
            value={featureUsedByCommunity}
            disabled
          />
        </div>

        {/* Fourth Row - Community Involved, Empty, Empty */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Was the community involved in planning or feedback?"
            value={communityInvolvedInPlanning}
            disabled
          />
          <div className="w-full"></div>
          <div className="w-full"></div>
        </div>
      </form>
    </div>
  );
};

export default FeatureInformation;